import { Component, EventEmitter, Input, Output } from '@angular/core';

import { EmailMessage } from '../../../core/services/email-client.types';

@Component({
  selector: 'app-message-list',
  standalone: false,
  templateUrl: './message-list.html',
  styleUrl: './message-list.scss',
})
export class MessageList {
  @Input() messages: EmailMessage[] = [];
  @Input() loading = false;
  @Input() emptyTitle = 'No email yet';
  @Input() emptyDescription = 'Start a new email to begin the conversation.';
  @Output() messageSelected = new EventEmitter<EmailMessage>();
  @Output() composeRequested = new EventEmitter<void>();
}
